
<script setup lang="ts">

import { onMounted, computed } from "vue";
import { ConditionScoreRowTemplate } from "@app/MyGarage/Components/ConditionScoreRowTemplate";

import { useViewModelInstance } from "../..";
import { useBackButton } from "@app/Components/Utilities";
import { ConditionType } from "@domain/Vehicle"; 

const model = await useViewModelInstance();

// Filter out the conditions that shouldnt be displayed, i.e. Recall
const filteredConditions = computed( () => model.vehicle.condition.conditions.filter( c => c.type != ConditionType.Recall ) );
onMounted( () => useBackButton() );

</script>

<template>

    <div class="apple-fix static w-full h-full bg-gray-900 overflow-y-auto pb-12">

        <div class="w-full bg-gradient-to-b dark:from-gray-900 dark:to-gray-850/80">

            <div class="p-6 3xl:pb-10 text-center">
                <h2 class="text-xl 3xl:text-2xl tracking-wider flex gap-2 justify-center items-center">
                    Setup your conditions
                </h2>
            </div>   

            <div class="text-center">

                <div class="inline-block rounded-lg py-2 pb-3 3xl:pt-4 3xl:pb-5 px-3 3xl:px-5 shadow
                            dark:bg-gray-700 mb-6">
                    <h1 class="text-lg 3xl:text-2xl uppercase text-center">
                        Your Score Is
                    </h1>
                    <div class="font-bold text-4xl 3xl:text-5xl -mt-0.5 3xl:mt-1 tracking-wider flex items-center">
                        <span class="font-bold leading-none">{{ model.vehicle.condition.score }}</span>
                        <span class="opacity-60 ml-1.5">/ 100</span>
                    </div>
                </div>                
            </div>
            
            <div class="3xl:text-xl">

                <div class="px-4 lg:px-6 3xl:px-10 pb-6">
                    <p class="mb-2 opacity-60">
                        The condition score helps you to quickly see the condition of your vehicle.
                    </p>
                </div>

                <!-- HEADER ROW -->
                <div class="grid grid-cols-12 items-center uppercase tracking-wider
                            px-4 lg:pl-6 py-3 shadow-lg z-10
                            border-b dark:border-gray-900">
                    <div class="col-span-8 text-left">Health Monitor</div>
                    <div class="col-span-4 text-right">Show</div>
                </div>

            </div>
                            
        </div>

        <div class="tracking-wider w-full static">
       
            <div class="bg-gradient-to-b dark:from-gray-850/80 dark:to-gray-850">
                        
                <div v-for="(condition,index) in filteredConditions"
                     :key="index"
                     class="py-2 items-center tracking-wider
                            border-b dark:border-gray-900
                            px-4 lg:px-6">

                    <ConditionScoreRowTemplate 
                        v-model="filteredConditions[ index ]"
                        :view-model="model"
                    />

                </div>

            </div>
        </div>

    </div>   
    
</template>
